import { defineMessages } from 'react-intl'

export default defineMessages({
    selectedOrderHeader: {
        id: 'containers.Accounting.AccountingMergeInvoicesPage.header.selected-order',
        defaultMessage: 'Orders to be merged with main order',
    },
    mainOrderSelectLabel: {
        id: 'containers.Accounting.AccountingMergeInvoicesPage.select.main-order',
        defaultMessage: 'Select main order',
    },
    mergeInvoiceOrdersButton: {
        id: 'containers.Accounting.AccountingMergeInvoicesPage.button.merge-invoice-orders',
        defaultMessage: 'Merge & Invoice Orders',
    },
    invoiceSingleOrderHeader: {
        id: 'containers.Accounting.AccountingMergeInvoicesPage.header.invoice-single-order',
        defaultMessage: 'Single Order To Invoice',
    },
    invoiceSingleOrderButton: {
        id: 'containers.Accounting.AccountingMergeInvoicesPage.button.invoice-single-order',
        defaultMessage: 'Invoice Order',
    },
})